<template>
  <nav class="hvh-nav">
    <ul class="hvh-nav__links mr-3">
      <li v-for="item in items" :class="'hvh-nav__link d-inline-block mx-2 py-4 ' + getItemClass(item)" :key="item.title">
        <a v-if="isItemLink(item)" :href="item.url">{{ item.title }}</a>
        <a v-else v-on:click="goto(item.url)">{{ item.title }}</a>
      </li>
    </ul>

    <a v-once :href="helpUrl" class="hvh-nav__help">
      <v-icon class="hvh-nav__icon">mdi-help-circle</v-icon>
      <span class="hvh-accessibly-hidden">Help</span>
    </a>

    <v-menu offset-y left attach>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" flat class="hvh-nav__profile-btn ma-0 pa-0">
          <v-icon class="hvh-nav__icon">mdi-account</v-icon>
          {{ profile.name }}
          <v-icon class="hvh-nav__icon">mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <div class="hvh-nav__items">
          <template v-for="item in profile.items">
            <a class="hvh-nav__subnav" v-on:click="goto(item.url)" :key="item.title">
              <v-icon class="hvh-nav__icon">{{ item.icon }}</v-icon>
              {{ item.title }}
            </a>
          </template>
        </div>
        <div class="hvh-nav__logout">
          <a v-on:click="goto(profile.logout.url)" class="hvh-nav__subnav">
            <v-icon class="hvh-nav__icon">{{ profile.logout.icon }}</v-icon>
            {{ profile.logout.title }}
          </a>
        </div>
      </v-list>
    </v-menu>
  </nav>
</template>

<script  >
export default {
  props: ['activeItemUrl', 'helpUrl', 'items', 'onNavigateHandler', 'profile'],
  methods: {
    getItemClass(item) {
      if (this.activeItemUrl === item.url) {
        return 'active';
      }
      return '';
    },
    isItemLink(item) {
      // link or button
      if (item.type && item.type.toLowerCase() === 'link') {
        return true;
      } else {
        return false;
      }
    },
    goto(url) {
      if (this.onNavigateHandler !== undefined) {
        this.onNavigateHandler(url);
      } else {
        location.href = url;
      }
    },
  },
};
</script>

<style lang="scss">
.hvh-nav {
  display: flex;
  font-size: rem(16px);
  align-items: stretch;
  line-height: 1;
  margin-left: auto;
}

.hvh-nav__items {
  padding: 20px 0;
  border-bottom: 1px solid $color-gray-1;
  margin-bottom: 16px;

  .v-icon {
    color: $color-gray-2;
    padding: 0 rem(13px);
  }
}

.hvh-nav__logout {
  margin-bottom: 16px;

  .v-icon {
    color: $color-gray-2;
    padding: 0 rem(13px);
  }
}

.hvh-nav__subnav {
  font-size: rem(16px);
  display: flex;
  color: $color-black;
  padding: 5px 0;

  &:hover {
    background: $color-gray-0;
  }
}

.hvh-nav__links {
  display: flex;
}

.hvh-nav__link {
  border-bottom: 3px solid transparent;

  a {
    color: $color-black;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
  }

  &.active,
  &:hover {
    border-bottom: 3px solid $color-teal;

    a {
      color: $color-teal;
    }
  }
}

.hvh-nav__help {
  border-left: 1px solid $color-gray-1;
}

.hvh-nav__icon {
  padding: 0 rem(20px);
  height: 100%;
}

.hvh-nav__profile-btn {
  text-transform: none;
  background-color: transparent;
  font-size: rem(16px);
  font-weight: 700;
  height: auto;
  border-left: 1px solid $color-gray-1;

  .v-icon.hvh-nav__icon {
    padding: 0 rem(15px);
    color: $color-gray-2;
  }

  .v-icon.mdi-menu-down {
    color: $color-gray-3;
  }
}

.hvh-dropdown-content {
  background: $color-white;
  list-style: none;
  margin: 0;
}
</style>
